(() => {
  if (customElements.get('bk-size-drawer')) return;
  class BkSizeDrawer extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      clearTimeout(this.readyTimer);
      this.abort = new AbortController();
      this.ready = false;
      this.hidden = false;
      this.prepare(0);
    }
    disconnectedCallback() {
      clearTimeout(this.readyTimer);
      this.closeGuide();
      this.abort?.abort();
      this.restoreScroll();
      this.source?.classList.remove('bk-size-source');
      this.form?.closest('.product-info__buy-buttons')?.classList.remove('bk-size-source');
      this.info?.classList.remove('bk-size-ready');
      this.ready = false;
      this.hidden = true;
    }
    prepare(attempt) {
      if (!this.isConnected || this.ready) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-bk-open]');
      this.submit = this.querySelector('[data-bk-submit]');
      this.error = this.querySelector('[data-bk-error]');
      this.cards = [...this.querySelectorAll('[data-bk-variant]')];
      const strings = this.querySelector('[data-bk-strings]');
      this.form = document.getElementById(this.dataset.form);
      this.source = this.parentElement?.querySelector('variant-picker');
      this.info = this.closest('.product-info');
      this.originalButton = this.form?.querySelector('button[type="submit"]');
      if (!strings?.textContent || !this.dialog || !this.trigger || !this.submit || !this.error || !this.cards.length || !this.info || !this.originalButton || !this.source?.product || typeof this.source.selectVariant !== 'function') {
        this.readyTimer = setTimeout(() => this.prepare(attempt + 1), attempt < 20 ? 100 : 500);
        return;
      }
      if (!this.dialog.showModal) return;
      this.strings = JSON.parse(strings.textContent);
      this.ready = true;
      const options = { signal: this.abort.signal };
      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-bk-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.restoreScroll();
        this.trigger.setAttribute('aria-expanded', 'false');
      }, options);
      for (const card of this.cards) card.addEventListener('click', () => {
        this.select(card);
        if (card.dataset.bkState === 'sold') this.add();
      }, options);
      this.submit.addEventListener('click', () => this.add(), options);
      this.querySelector('[data-bk-guide]').addEventListener('click', () => this.openGuide(), options);
      this.form.addEventListener('variant:change', event => {
        if (this.selected && event.detail.variant) this.render(this.cards.find(card => card.dataset.bkVariant === String(event.detail.variant.id)));
      }, options);
      this.form.addEventListener('cart:error', event => {
        this.open();
        this.fail(event.detail?.error);
      }, options);
      this.form.addEventListener('variant:add', () => this.success(), options);
      document.addEventListener('cart:change', event => {
        if (this.busy && event.detail?.baseEvent === 'variant:add') this.success();
      }, options);
      this.form.addEventListener('submit', event => {
        if (this.selected && this.selected.dataset.bkState !== 'sold') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.open();
      }, { ...options, capture: true });
      this.source.classList.add('bk-size-source');
      this.form.closest('.product-info__buy-buttons')?.classList.add('bk-size-source');
      this.hidden = false;
      this.trigger.disabled = false;
      this.trigger.setAttribute('aria-busy', 'false');
      this.info.classList.add('bk-size-ready');
      const linked = this.cards.find(card => card.dataset.bkVariant === this.dataset.selected);
      if (linked) this.render(linked);
    }
    open() {
      if (this.dialog.open) return;
      this.querySelector('[data-bk-guide]').hidden = !this.info.querySelector('.scalechart-trigger-btn');
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
    }
    restoreScroll() {
      if (this.previousOverflow === undefined) return;
      document.documentElement.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
    }
    openGuide() {
      const guide = this.info.querySelector('.scalechart-trigger-btn');
      if (!guide || this.guideDialog) return;
      const chart = document.getElementById(guide.id.replace('scalechart-trigger-', 'scalechart-modal-'));
      if (!chart) return;
      this.guideChart = chart;
      this.guidePlaceholder = document.createComment('');
      chart.before(this.guidePlaceholder);
      const overlay = document.createElement('dialog');
      overlay.className = 'bk-size-guide-dialog';
      overlay.setAttribute('aria-label', this.querySelector('[data-bk-guide]').textContent.trim());
      document.body.append(overlay);
      this.guideDialog = overlay;
      guide.click();
      overlay.append(chart);
      const dismiss = () => {
        chart.querySelector('.scalechart-close')?.click();
        this.closeGuide();
      };
      overlay.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
      overlay.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        dismiss();
      });
      this.guideObserver = new MutationObserver(() => {
        if (getComputedStyle(chart).display === 'none') this.closeGuide();
      });
      this.guideObserver.observe(chart, { attributes: true, attributeFilter: ['style', 'class'] });
      overlay.showModal();
      chart.querySelector('.scalechart-close')?.focus();
    }
    closeGuide() {
      if (!this.guideDialog) return;
      this.guideObserver?.disconnect();
      this.guidePlaceholder?.replaceWith(this.guideChart);
      this.guideDialog.close();
      this.guideDialog.remove();
      this.guideDialog = null;
      if (this.dialog?.open && this.isConnected) this.querySelector('[data-bk-guide]').focus();
    }
    select(card) {
      if (this.busy) return;
      this.error.hidden = true;
      this.render(card);
      const option = [...this.source.querySelectorAll('[role="option"]')].find(item => item.getAttribute('value') === card.dataset.bkTitle);
      if (option) option.click();
      else this.source.selectVariant(Number(card.dataset.bkVariant));
      if (String(this.form.elements.namedItem('id').value) !== card.dataset.bkVariant) this.fail(this.strings.error);
    }
    render(card) {
      if (!card) return;
      this.selected = card;
      for (const item of this.cards) item.setAttribute('aria-pressed', String(item === card));
      const data = card.dataset;
      this.querySelector('[data-bk-trigger-label]').textContent = `${this.strings.selected}: ${data.bkTitle}`;
      const price = this.querySelector('[data-bk-price]');
      price.textContent = data.bkPrice;
      price.classList.toggle('bk-size-price--sale', Boolean(data.bkCompare));
      const compare = this.querySelector('[data-bk-compare]');
      compare.textContent = data.bkCompare;
      compare.hidden = !data.bkCompare;
      this.querySelector('[data-bk-delivery]').textContent = `${data.bkTitle} · ${this.strings[data.bkState]}`;
      this.submit.textContent = data.bkState === 'sold' ? this.strings.notify : `${this.strings.add} · ${data.bkPrice}`;
      this.submit.disabled = false;
      for (const badge of this.info.querySelectorAll('span[data-bk-saving]')) {
        badge.textContent = data.bkSaving || '';
        badge.hidden = !data.bkSaving;
      }
      for (const shipping of this.closest('.shopify-section').querySelectorAll('[data-bk-shipping]')) {
        shipping.dataset.state = data.bkState;
        shipping.querySelector('[data-bk-shipping-text]').textContent = data.bkState === 'stock' ? this.strings.shipping : this.strings[data.bkState];
      }
      for (const badge of this.closest('.shopify-section').querySelectorAll('[data-bk-gallery-fast]')) badge.hidden = data.bkState !== 'stock';
    }
    add() {
      if (!this.selected || this.busy) return;
      if (this.selected.dataset.bkState === 'sold') {
        const link = [...this.source.querySelectorAll('.bk-restock-link')].find(item => item.dataset.restockSize === this.selected.dataset.bkTitle);
        if (!link) { this.fail(this.strings.error); return; }
        this.dialog.close();
        link.click();
        return;
      }
      if (String(this.form.elements.namedItem('id').value) !== this.selected.dataset.bkVariant || this.originalButton.disabled) {
        this.fail(this.strings.error);
        return;
      }
      // Release the modal before Impact or an app opens its cart/upsell overlay.
      this.dialog.close();
      this.originalButton.click();
    }
    success() {
      this.busy = false;
      this.submit.removeAttribute('aria-busy');
      this.render(this.selected);
      if (this.dialog.open) this.dialog.close();
    }
    fail(message) {
      this.busy = false;
      this.submit.removeAttribute('aria-busy');
      this.render(this.selected);
      this.error.textContent = typeof message === 'string' ? message : this.strings.error;
      this.error.hidden = false;
    }
  }
  customElements.define('bk-size-drawer', BkSizeDrawer);
})();

